/* Customer care enhancement. Policy wording and Shopify privacy forms stay intact. */
(() => {
  const policy = document.querySelector('.shopify-policy__container');
  if (policy) {
    const title = policy.querySelector('h1')?.textContent || '';
    const article = policy.querySelector('.rte');
    const hero = document.getElementById('BaboPolicyHero')?.content.cloneNode(true);
    const navigation = document.getElementById('BaboSupportNav')?.content.cloneNode(true);
    if (article && hero && navigation) {
      const page = document.createElement('section'); page.className = 'support-page';
      const container = document.createElement('div'); container.className = 'container support-container';
      hero.querySelector('h1').textContent = title;
      const layout = document.createElement('div'); layout.className = 'support-layout';
      const aside = document.createElement('aside'); aside.className = 'support-sidebar'; aside.append(navigation);
      const main = document.createElement('div'); main.className = 'support-main';
      article.classList.add('support-article'); main.append(article);
      layout.append(aside, main); container.append(hero, layout); page.append(container); policy.replaceWith(page);
      const path = window.location.pathname;
      aside.querySelectorAll('a').forEach(a => { if (a.getAttribute('href') === path) a.setAttribute('aria-current', 'page'); });
      const headings = new Set(['Processing time','Where we ship','Free tracked shipping to all markets','Duties and taxes','Lost or damaged in transit','30-night carry trial','How to start a return','Condition','Exchanges','Backed-for-life warranty','Refund method','Company','Trademarks and intellectual property','Reporting concerns']);
      article.querySelectorAll(':scope > p').forEach(p => {
        if (headings.has(p.textContent.trim())) { const h = document.createElement('h2'); h.textContent = p.textContent; p.replaceWith(h); }
      });
    }
  }
  const faq = document.querySelector('[data-support-page="faqs"] .support-article');
  if (faq) faq.querySelectorAll(':scope > p').forEach(p => {
    const question = p.firstElementChild;
    if (question?.tagName !== 'STRONG' || !question.textContent.includes('?')) return;
    const details = document.createElement('details'); const summary = document.createElement('summary');
    summary.textContent = question.textContent; question.remove();
    const answer = document.createElement('div'); answer.className = 'support-answer';
    while (p.firstChild) answer.append(p.firstChild);
    details.append(summary, answer); p.replaceWith(details);
  });
  document.querySelectorAll('.support-article').forEach(article => {
    const headings = [...article.querySelectorAll(':scope > h2, :scope > h3')];
    if (headings.length < 3) return;
    const toc = document.createElement('nav'); toc.className = 'support-toc';
    headings.forEach((heading, i) => {
      heading.id ||= `babo-section-${i + 1}`;
      const a = document.createElement('a'); a.href = `#${heading.id}`; a.textContent = heading.textContent.replace(/^\d+\s*[·.]\s*/, ''); toc.append(a);
    });
    article.before(toc);
  });
})();
